import { IciFlags } from 'src/generated/signalR/ici-flags';
import { Enum, EnumType } from 'ts-jenum';

@Enum<GreetingIciTypeEnum>('name')
export class GreetingIciTypeEnum extends EnumType<GreetingIciTypeEnum>() {
   static readonly ALL = new GreetingIciTypeEnum('ALL', 'common.settings.agent_greetings.type.all', IciFlags.UNKNOWN, 0);

   static readonly INBOUND_INTERNAL = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL',
      'common.settings.agent_greetings.type.inbound.internal.all',
      IciFlags.INBOUND + IciFlags.INTERNAL,
      1
   );

   static readonly INBOUND_INTERNAL_BUSY = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL_BUSY',
      'common.settings.agent_greetings.type.inbound.internal.busy',
      IciFlags.INBOUND + IciFlags.INTERNAL + IciFlags.BUSY,
      2
   );

   static readonly INBOUND_INTERNAL_NO_ANSWER = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL_NO_ANSWER',
      'common.settings.agent_greetings.type.inbound.internal.no_answer',
      IciFlags.INBOUND + IciFlags.INTERNAL + IciFlags.NO_ANSWER,
      3
   );

   static readonly INBOUND_INTERNAL_FORWARDED = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL_FORWARDED',
      'common.settings.agent_greetings.type.inbound.internal.forwarded',
      IciFlags.INBOUND + IciFlags.INTERNAL + IciFlags.FORWARDED,
      4
   );

   static readonly INBOUND_INTERNAL_REDIRECTED = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL_REDIRECTED',
      'common.settings.agent_greetings.type.inbound.internal.transferred',
      IciFlags.INBOUND + IciFlags.INTERNAL + IciFlags.TRANSFERRED,
      5
   );

   static readonly INBOUND_INTERNAL_FALLBACK = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL_FALLBACK',
      'common.settings.agent_greetings.type.inbound.internal.fallback.all',
      IciFlags.INBOUND + IciFlags.INTERNAL + IciFlags.FALLBACK,
      6
   );

   static readonly INBOUND_INTERNAL_FALLBACK_BUSY = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL_FALLBACK_BUSY',
      'common.settings.agent_greetings.type.inbound.internal.fallback.busy',
      IciFlags.INBOUND + IciFlags.INTERNAL + IciFlags.FALLBACK + IciFlags.BUSY,
      7
   );

   static readonly INBOUND_INTERNAL_FALLBACK_NO_ANSWER = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL_FALLBACK_NO_ANSWER',
      'common.settings.agent_greetings.type.inbound.internal.fallback.no_answer',
      IciFlags.INBOUND + IciFlags.INTERNAL + IciFlags.FALLBACK + IciFlags.NO_ANSWER,
      8
   );

   static readonly INBOUND_INTERNAL_FALLBACK_FORWARDED = new GreetingIciTypeEnum(
      'INBOUND_INTERNAL_FALLBACK_FORWARDED',
      'common.settings.agent_greetings.type.inbound.internal.fallback.forwarded',
      IciFlags.INBOUND + IciFlags.INTERNAL + IciFlags.FALLBACK + IciFlags.FORWARDED,
      9
   );

   static readonly INBOUND_EXTERNAL = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL',
      'common.settings.agent_greetings.type.inbound.external.all',
      IciFlags.INBOUND + IciFlags.EXTERNAL,
      10
   );

   static readonly INBOUND_EXTERNAL_BUSY = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL_BUSY',
      'common.settings.agent_greetings.type.inbound.external.busy',
      IciFlags.INBOUND + IciFlags.EXTERNAL + IciFlags.BUSY,
      11
   );

   static readonly INBOUND_EXTERNAL_NO_ANSWER = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL_NO_ANSWER',
      'common.settings.agent_greetings.type.inbound.external.no_answer',
      IciFlags.INBOUND + IciFlags.EXTERNAL + IciFlags.NO_ANSWER,
      12
   );

   static readonly INBOUND_EXTERNAL_FORWARDED = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL_FORWARDED',
      'common.settings.agent_greetings.type.inbound.external.forwarded',
      IciFlags.INBOUND + IciFlags.EXTERNAL + IciFlags.FORWARDED,
      13
   );

   static readonly INBOUND_EXTERNAL_REDIRECTED = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL_REDIRECTED',
      'common.settings.agent_greetings.type.inbound.external.transferred',
      IciFlags.INBOUND + IciFlags.EXTERNAL + IciFlags.TRANSFERRED,
      14
   );

   static readonly INBOUND_EXTERNAL_FALLBACK = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL_FALLBACK',
      'common.settings.agent_greetings.type.inbound.external.fallback.all',
      IciFlags.INBOUND + IciFlags.EXTERNAL + IciFlags.FALLBACK,
      15
   );

   static readonly INBOUND_EXTERNAL_FALLBACK_BUSY = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL_FALLBACK_BUSY',
      'common.settings.agent_greetings.type.inbound.external.fallback.busy',
      IciFlags.INBOUND + IciFlags.EXTERNAL + IciFlags.FALLBACK + IciFlags.BUSY,
      16
   );

   static readonly INBOUND_EXTERNAL_FALLBACK_NO_ANSWER = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL_FALLBACK_NO_ANSWER',
      'common.settings.agent_greetings.type.inbound.external.fallback.no_answer',
      IciFlags.INBOUND + IciFlags.EXTERNAL + IciFlags.FALLBACK + IciFlags.NO_ANSWER,
      17
   );

   static readonly INBOUND_EXTERNAL_FALLBACK_FORWARDED = new GreetingIciTypeEnum(
      'INBOUND_EXTERNAL_FALLBACK_FORWARDED',
      'common.settings.agent_greetings.type.inbound.external.fallback.forwarded',
      IciFlags.INBOUND + IciFlags.EXTERNAL + IciFlags.FALLBACK + IciFlags.FORWARDED,
      18
   );

   private constructor(public name: string, public translation: string, public value: number, public displayOrder: number) {
      super();
   }
}
